import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import characterImg from "../../assets/Group 12.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="brand-logo">
         
            <span className="brand-name">Judith Matute</span>
          </div>
          <p className="brand-tagline">
            Explorer, creative,<br />
            designer, engineer
          </p>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">Projects</h3>
          <nav className="footer-nav">
            <Link to="/projects?project=flowOptimization">Flow Optimization</Link>
            <Link to="/projects?project=designSystem">Design System</Link>
 
            <Link to="/projects?project=art">Art</Link>

          </nav>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">About me</h3>
          <nav className="footer-nav">
            <Link to="/about">About me</Link>
            <a 
              href="/cv_judithmatute.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="link-arrow"
            >
              Resume <span>↗</span>
            </a>
          </nav>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">Social Media</h3>
          <nav className="footer-nav">
            <a 
              href="https://www.linkedin.com/in/judithmatutedelavega/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="link-arrow"
            >
              LinkedIn <span>↗</span>
            </a>
     
          </nav>
        </div>
      </div>

      <div className="footer-illustration">
        <img src={characterImg} alt="Running Character" />
      </div>

      <div className="footer-bottom">
        <p className="copyright">© 2025 Judith Matute</p>
        <p className="credits">Designed and developed by Judith Matute</p>
      </div>
    </footer>
  );
}